import { mapAppRouteToReactRouterDomRoute } from 'domain/routes/route.mapper';
import { RouteObject } from 'react-router-dom';
import { Enterprise } from 'redux/slices/enterprises/type';
import { hasPermissions } from 'utils/permissions';
import { AppModules } from '../config/modules';
import { AppRoute } from '../domain/routes/route.type';

export const getAppRoutes = (
	requiredAuth: boolean,
	permissions: any,
	enterprise: Enterprise
): RouteObject[] => {
	const getRoutesFromModuleName = (moduleName: string): AppRoute[] | null => {
		try {
			const { routes } = require(`ui/${moduleName}/routes`) as {
				routes: AppRoute[];
			};
			return routes;
		} catch (e) {
			console.error(`Can not load routes from module ${moduleName}`);
			return null;
		}
	};

	const mapAppRoutes = (userPermissions: any): RouteObject[] => {
		let appRoutes: AppRoute[] = [];
		for (let index = 0; index < AppModules.length; index++) {
			const moduleName = AppModules[index];
			const routes = getRoutesFromModuleName(moduleName);
			if (!routes) continue;

			const routesFromAuthState = routes.filter(
				route =>
					!!route.isPrivate === requiredAuth &&
					(!route.permissions ||
						hasPermissions(route.permissions, userPermissions, enterprise))
			);

			appRoutes.push(...routesFromAuthState);
		}
		return appRoutes.map(mapAppRouteToReactRouterDomRoute);
	};

	return mapAppRoutes(permissions);
};
